import {
  QUERY_KEYS,
  soCaiColumns,
  thanhToanPhaiThuColumns,
  thanhToanPhaiTraColumns,
  thueVatDauVaoColumns
} from '@/constants';
import { InfoDropdown } from '@/components/custom/erp';

const PhieuThuInfoDropdown = ({ uuid, ma_ct }: { uuid: string; ma_ct?: string }) => (
  <InfoDropdown
    uuid={uuid}
    ma_ct={ma_ct}
    tableItems={[
      {
        title: 'Xem sổ cái',
        endpoint: QUERY_KEYS.SO_CAI,
        columns: soCaiColumns,
        group: 1
      },
      {
        title: 'Thanh toán phải thu',
        endpoint: QUERY_KEYS.THANH_TOAN_PHAI_THU,
        columns: thanhToanPhaiThuColumns,
        group: 1
      },
      {
        title: 'Thanh toán phải trả',
        endpoint: QUERY_KEYS.THANH_TOAN_PHAI_TRA,
        columns: thanhToanPhaiTraColumns,
        group: 1
      },
      {
        title: 'Thuế VAT đầu vào',
        endpoint: QUERY_KEYS.THUE_VAT_DAU_VAO,
        columns: thueVatDauVaoColumns,
        group: 1
      }
    ]}
  />
);

export default PhieuThuInfoDropdown;
